<template>
    <v-main style="position: absolute;">
      <div>
          <v-card >
            <v-img
              min-height="250"
              src="https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/web%2Ffriend1.jpg?alt=media&token=af17e2ed-63ef-4ad5-b1a6-a1f757244325"
              style="background-color:FFB8A1"
            >
            <v-chip
        class="ma-2"
        color="rgb(235 246 130)"
        label
        text-color="black"
      >
      {{ $t("message.friendFetFriend") }}
        <v-icon style="font-size: 20px;margin-left: 5px;">mdi-account-voice</v-icon>
      </v-chip>
            </v-img>
          </v-card>
      </div>
      <div style="position: relative;top: -50px;">
        <div elevation="1" style="background-color:white;;border-top-left-radius: 44px;border-top-right-radius: 44px;" class="pa-6">
          <div style="text-align: end;">
            <v-btn color="antiquewhite" small @click="dialogHisoty = true, getFriendForLog()">
              {{ $t("message.getFriendHistory") }}<v-icon class="ml-2" color="black">mdi-history</v-icon>
            </v-btn>
          </div>
          <div class="mb-5" v-if="dataFriendGetFriend.statusUpdateB.toLowerCase() === 'true'">
            <p :style="'padding-left: 10px;border-left: solid ' + $bgColor + ' 5px;font-size: 17px;margin-bottom: 10px !important;'">{{ $t("message.inviteUseservice") }}</p>
            <v-card
              class="mx-auto"
              max-width="450"
              style="border-radius: 25px;"
            >
              <v-img
                :src="dataFriendGetFriend.pictureB === null ?  require('@/assets/activity1.png') : dataFriendGetFriend.pictureB"
                :aspect-ratio="14/7"
              >
              </v-img>
              <v-card-text style="padding: 10px !important;display: grid;grid-template-areas:'main main main main right right';gap: 10px;">
                <div style="grid-area: main;">
                  <div style="color: black;font-size: 15px;">
                  {{dataFriendGetFriend.massageB}}
                  </div>
                  <div style="padding-left: 5px;display:flex;flex-wrap: wrap;">
                     <img
                      v-if="profile.pictureUrl"
                      style="
                        border-color: white;
                        height: 20px;
                        margin-right: 5px;
                      "
                      alt="Avatar"
                      :src="checkpushCustom() ? HEXTHEMELMG(newData.levelColor) ? $images.point : $images.pointWhite : require('@/assets/coin.png') "
                    /> <p class="mb-0">{{ $t("message.pointsEarned") }}</p> <p class="mb-0 mx-1" style="color:rgb(255, 114, 94);"> {{dataFriendGetFriend.point_inviterB}} </p><p class="mb-0">{{ $t("message.point") }}</p>
                  </div>
                  <div style="padding-left: 5px;display:flex;flex-wrap: wrap;" class="mb-0">
                    <img
                      v-if="profile.pictureUrl"
                      style="
                        border-color: white;
                        height: 20px;
                        margin-right: 5px;
                      "
                      alt="Avatar"
                      :src="require('@/assets/user.png')"
                    /> <p class="mb-0">{{ $t("message.canInvite") }} </p>
                    <p class="mb-0 mx-1" style="color:rgb(255, 114, 94);" v-if="dataFriendGetFriend.limit_addB === 'ไม่จำกัดจำนวน'"> {{$i18n.locale === 'th' ? dataFriendGetFriend.limit_addB : this.$t("message.NoLimit")}} </p>
                    <p class="mb-0 mx-1" style="color:rgb(255, 114, 94);" v-if="dataFriendGetFriend.limit_addB === 'จำกัดจำนวน'"> {{dataFriendGetFriend.count_memB}} </p>
                    <p class="mb-0"> {{ $t("message.countTime") }}</p>
                    <p style="color:red" v-if="qoutaServiceStatus === true">*{{ $t("message.referralQuota") }}</p>
                  </div>
                </div>
                <div style="grid-area: right;display: flex;align-items: center;">
                  <v-btn color="red" style="color:white;" small :disabled="chckCountService()" @click="dialogInviteService = true">{{ $t("message.startActivity") }}</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </div>
          <div v-if="dataFriendGetFriend.statusUpdateA.toLowerCase() === 'true'">
            <div style="display:flex">
              <p :style="'padding-left: 10px;border-left: solid ' + $bgColor + ' 5px;font-size: 17px;margin-bottom: 10px !important;'">{{ $t("message.Invitemembership") }}</p>
              <!-- <p>ประวัติชวนเพื่อน<v-icon>mdi-history</v-icon></p> -->
            </div>
            <v-card
              class="mx-auto"
              max-width="450"
              style="border-radius: 25px;"
            >
              <v-img
                :src="dataFriendGetFriend.pictureA === null ?  require('@/assets/activity2.png') : dataFriendGetFriend.pictureA"
                :aspect-ratio="14/7"
                style="position: relative;"
              >
              <!-- <p style="text-align: right;
                  position: absolute;
                  background-color: #928a8a;
                  right: 10px;
                  padding: 2px 6px 2px 6px;
                  color: white;
                  top: 10px;">ประวัติชวนเพื่อน<v-icon class="ml-2" color="white">mdi-history</v-icon></p> -->
              </v-img>
              <v-card-text style="padding: 10px !important;display: grid;grid-template-areas:'main main main main right right';gap: 10px;">
                <div style="grid-area: main;">
                  <div style="color: black;font-size: 15px;">
                    {{dataFriendGetFriend.massageA}}
                  </div>
                  <div style="padding-left: 5px;display:flex;flex-wrap: wrap;">
                    <img
                      v-if="profile.pictureUrl"
                      style="
                        border-color: white;
                        height: 20px;
                        margin-right: 5px;
                      "
                      alt="Avatar"
                      :src="checkpushCustom() ? HEXTHEMELMG(newData.levelColor) ? $images.point : $images.pointWhite : require('@/assets/coin.png') "
                    /> <p class="mb-0">{{ $t("message.pointsEarned") }}</p> <p class="mb-0 mx-1" style="color:rgb(255, 114, 94);"> {{dataFriendGetFriend.point_inviterA}} </p><p class="mb-0">{{ $t("message.point") }}</p>
                  </div>
                  <div style="padding-left: 5px;display:flex;flex-wrap: wrap;">
                    <img
                      v-if="profile.pictureUrl"
                      style="
                        border-color: white;
                        height: 20px;
                        margin-right: 5px;
                      "
                      alt="Avatar"
                      :src="require('@/assets/user.png')"
                    /><p class="mb-0">{{ $t("message.canInvite") }} </p>
                    <p class="mb-0 mx-1" style="color:rgb(255, 114, 94);" v-if="dataFriendGetFriend.limit_addA === 'ไม่จำกัดจำนวน'"> {{$i18n.locale === 'th' ? dataFriendGetFriend.limit_addA : this.$t("message.NoLimit")}} </p>
                    <p class="mb-0 mx-1" style="color:rgb(255, 114, 94);" v-if="dataFriendGetFriend.limit_addA === 'จำกัดจำนวน'"> {{dataFriendGetFriend.count_memA}} </p>
                    <p class="mb-0">{{ $t("message.countTime") }}</p>
                    <p style="color:red" v-if="qoutaRegisStatus === true">*{{ $t("message.referralQuota") }}</p>
                  </div>
                </div>
                <div style="grid-area: right;display: flex;align-items: center;">
                  <v-btn color="red" style="color:white;" small :disabled="chckCountRegis()" @click="dialogInviteRegis = true">{{ $t("message.startActivity") }}</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </div>

      <!-- dialog กิจกรรมชวนใช้บริการ-->
      <v-dialog
      v-model="dialogInviteService"
      fullscreen
      hide-overlay
      >
        <v-card class="pa-1">
          <div style="text-align: end;" class="pr-4 pt-3 mb-2">
            <v-btn
                small
                icon
                @click="dialogInviteService = false"
              >
              <v-icon color="red">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-list
            three-line
            subheader
            style="text-align: center;"
          >
            <div class="mb-6" style="font-size: 24px;color: #871B12;">{{ $t("message.InviteServiceReceive") }} {{dataFriendGetFriend.point_inviterB}} {{ $t("message.point") }}</div>
            <v-list-item class="mt-0">
               <v-img
               height="320"
               contain
                src="https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/web%2FGroup-591.png?alt=media&token=9887a744-01b7-444b-9791-b11e846abebd"
              />
            </v-list-item>
          </v-list>
          <v-list
            three-line
            subheader
          >
            <v-list-item class="px-7">
              <v-list-item-content class="pt-1 mt-5">
                <v-list-item-title class="mb-3" style="display: flex;"><div style="color: #FF725E;">{{ $t("message.howtoGetFriend") }}</div><div class="ml-2"> {{ $t("message.shareLinkLine") }}</div></v-list-item-title>
                  <div style="display: inline-flex;justify-content: left;">
                    <div style="display: inline-grid;" @click="sendShareService">
                        <v-icon class="iconify" style="font-size: 54px;" color="green" data-icon="ri:line-fill"></v-icon>
                        <div style="text-align: center;">Line</div>
                    </div>
                    <!-- <div style="display: inline-grid;" @click="share()">
                        <v-icon  style="font-size: 54px;">mdi-web-box</v-icon>
                        <div style="text-align: center;">อื่นๆ</div>
                    </div> -->
                  </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-dialog>

      <!-- dialog กิจกรรมชวนสมัครสมาชิก-->
      <v-dialog
      v-model="dialogInviteRegis"
      fullscreen
      hide-overlay
      >
        <v-card class="pa-1">
          <div style="text-align: end;" class="pr-4 pt-3 mb-2">
            <v-btn
                small
                icon
                @click="dialogInviteRegis = false"
              >
              <v-icon color="red">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-list
            three-line
            subheader
            style="text-align: center;"
          >
            <div class="mb-6" style="font-size: 24px;color: #871B12;">{{ $t("message.EarnInvitingFriends") }} {{dataFriendGetFriend.point_inviterA}} {{ $t("message.point") }}</div>
            <v-list-item class="mt-0">
               <v-img
               height="320"
               contain
                src="https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/web%2FGroup-591.png?alt=media&token=9887a744-01b7-444b-9791-b11e846abebd"
              />
            </v-list-item>
          </v-list>
          <v-list
            three-line
            subheader
          >
            <div class="px-7 mt-5" style="display: flex;font-size: 18px;">
              <div>{{ $t("message.wayGetFriend") }} </div><div class="ml-2" style="color:#FF725E">{{ $t("message.towWay") }}</div>
            </div>
            <v-list-item class="px-7 mb-3">
              <v-list-item-content class="pb-0 pt-4">
                <v-list-item-title class="mb-5" style="display: flex;"><div style="color: #FF725E;">{{ $t("message.Method1") }}</div><div class="ml-2"> {{ $t("message.shareCode") }}</div></v-list-item-title>
                  <div style="display: inline-flex;">
                    <div style="padding: 16px 25px;background: #D9DDDC;border-radius: 27px 0px 0px 27px;" id="myInput">{{member.memberId}}</div>
                    <div style="border-radius: 0px 27px 27px 0px;padding: 16px 16px;background: #FF725E;color:white" @click="copyTextformView()">{{ $t("message.copy") }}</div>
                  </div>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="px-7">
              <v-list-item-content class="pt-1">
                <v-list-item-title class="mb-3" style="display: flex;"><div style="color: #FF725E;">{{ $t("message.Method2") }}</div><div class="ml-2"> {{ $t("message.shareLinkLine") }}</div></v-list-item-title>
                  <div style="display: inline-flex;justify-content: left;">
                    <div style="display: inline-grid;" @click="sendShareRegister">
                        <v-icon class="iconify" style="font-size: 54px;" color="green" data-icon="ri:line-fill"></v-icon>
                        <div style="text-align: center;">Line</div>
                    </div>
                  </div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-dialog>

      <!-- dialog ประวัติ-->
      <v-dialog
      v-model="dialogHisoty"
      scrollable
      >
        <v-card style="width:100px" min-height="550px">
          <v-card-title class="pa-3" :style="'border-bottom: solid #e1dddd;background-color: ' + $bgColor + ';color:' + $textcolor">{{ $t("message.getFriendHistory") }}</v-card-title>
          <v-card-text class="pa-0" style="height: 300px;">
            <v-timeline
              dense
              style="width:280px"
                >
              <v-timeline-item
                v-for="(item, i) in dataFriendGetFriendLog"
                :key="i"
                large
              >
              <div v-if="item.type === 'inviteRegister-FriendGetFriend'">{{ $t("message.Invitemembership") }}</div>
              <template v-slot:icon>
                <v-avatar>
                  <img :src="item.pictureInviteTo">
                </v-avatar>
              </template>
                <v-row class="pt-4" justify="space-between">
                  <v-col cols="7" class="pt-0">
                    <strong>{{item.lineNameInviteTo}}</strong>
                  </v-col>
                  <v-col cols="5" class="px-0 pt-0">
                    <img
                  v-if="profile.pictureUrl"
                  style="
                    border-color: white;
                    height: 17px;
                  "
                  class="mr-2 mb-1"
                  alt="Avatar"
                  :src="checkpushCustom() ? HEXTHEMELMG(newData.levelColor) ? $images.point : $images.pointWhite : require('@/assets/coin.png') "
                />
                    <strong>{{item.inviteFormGetPoint}}</strong> {{ $t("message.point") }}
                  </v-col>
                </v-row>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
          <!-- <div style="text-align: end;" class="pr-4 pt-3 mb-2">
            <v-btn
                small
                icon
                @click="dialogHisoty = false"
              >
              <v-icon color="red">mdi-close</v-icon>
            </v-btn>
          </div>
         <div style="text-align: center;">
           <p>ชวนเพื่อนทั้งหมด</p>
           <p>{{countLog}}</p>
         </div>
         <v-card-text class="pa-3">
           test
         </v-card-text> -->
         <v-card-actions class="pb-3" :style="'justify-content: space-between;background-color: ' + $bgColor + ';color:' + $textcolor">
           <p class="mb-0">{{ $t("message.point") }}</p>
           <p class="mb-0">  <img
                  v-if="profile.pictureUrl"
                  style="
                    border-color: white;
                    height: 17px;
                  "
                  class="mr-2 mb-1"
                  alt="Avatar"
                  :src="checkpushCustom() ? HEXTHEMELMG($bgColor) ? $images.point : $images.pointWhite : require('@/assets/coin.png') "
                />{{allPoint}} {{ $t("message.point") }}</p>
         </v-card-actions>
        </v-card>
      </v-dialog>
    </v-main>
</template>
<style scoped>
/* .card1 {
  height: 100%;
  overflow: hidden;
  background-color: --color_headline1 !important;
  border-radius: 0px 0px 0px 0px;
} */
.card {
  height: 100%;
  overflow: hidden;
}
.cardbg {
  background-repeat: no-repeat !important;
  background-size: 90% 110% !important;
  background-attachment: fixed;
  background-position: center;
}
</style>
<script>
import HeaderProfile from '../../HeaderProfile'
import MenuItem from '../../MenuItem'
import AllActivity from '../../AllActivity'
import axios from 'axios'
import ActivityBackup from '../../ActivityBackup'
import { mapGetters } from 'vuex'

export default {
  name: 'ActivityMain',
  metaInfo: {
    // title: 'My Activity',
    meta: [
      { property: `og:title`, content: 'กิจกรรม' },
      { property: 'og:image', content: 'https://storage.googleapis.com/betask-linked/static/upload/Shop/SH261_20221229231505684117.jpeg' }
    ]
  },
  components: {
    'header-profile': HeaderProfile,
    'menu-item': MenuItem,
    'all-activity': AllActivity,
    'activity-backup': ActivityBackup
  },
  data () {
    return {
      activity: null,
      liffId: null,
      member: null,
      dialogInviteRegis: false,
      dialogInviteService: false,
      dataFriendGetFriend: null,
      shareLinkForline: '',
      ActivityFriendGetFriend: null,
      dialogHisoty: false,
      dataFriendGetFriendLog: null,
      countLog: 0,
      qoutaRegisStatus: false,
      qoutaServiceStatus: false,
      allPoint: null,
      profile: [],
      shareData: {
        title: 'MDN',
        text: 'Learn web development on MDN!',
        url: `https://liff.line.me/1656906322-JN5MM8Ep/home?shopId=${this.shopId}` // ไม่อ่าน this. shopId
      },
      flex: null,
      link: null
    }
  },
  async mounted () {
    if (this.$route.query.shopId) {
      if (typeof this.$session.getAll().shopId === 'undefined') {
        this.$session.remove('shopId')
        this.$session.start()
        this.$session.set('shopId', this.$route.query.shopId)
      }
    }
    // await axios
    //   .get(
    //     'https://api-belinked.betaskthai.tech' +
    //         '/sys_shop/get?shopId=' +
    //         this.shopId + '1'
    //   )
    //   .then(async (result) => {
    //     if (result.data.status === undefined) {
    //       this.link = 'https://liff.line.me/1656906322-JN5MM8Ep/RegisterMember?type=loyaltyLinked&shopId='
    //       console.log('result.data22', result.data === undefined)
    //     } else {
    //       console.log('result.data', result.data)
    //       this.link = 'https://liff.line.me/1656906322-JN5MM8Ep/RegisterMember?shopId='
    //       this.statusBelink = false
    //     }
    //   })
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    await this.getFriendForCheck()
    await this.checkOpenBelinked()
    window.scrollTo(0, 0)
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),

    async getActivity () {
      const result = await this.callBeTaskAPI('get', `/activity/line/get`)
      if (Array.isArray(result)) {
        this.activity = result
      }
    },
    chckCountRegis () {
      if (this.dataFriendGetFriend.statusUpdateA === 'False') {
        return true
      } else {
        if (this.dataFriendGetFriend.limit_addA === 'จำกัดจำนวน') {
          if (this.dataFriendGetFriend.count_memA > this.member.countInviteRegis) {
            return false
          } else {
            this.qoutaRegisStatus = true
            return true
          }
        } else {
          return false
        }
      }
    },
    chckCountService () {
      if (this.dataFriendGetFriend.statusUpdateB === 'False') {
        return true
      } else {
        if (this.dataFriendGetFriend.limit_addB === 'จำกัดจำนวน') {
          if (this.dataFriendGetFriend.count_memB > this.member.countInviteService) {
            return false
          } else {
            this.qoutaServiceStatus = true
            return true
          }
        } else {
          return false
        }
      }
    },
    copyTextformView () {
      let textToCopyformUpdate = document.getElementById('myInput')
      navigator.clipboard.writeText(textToCopyformUpdate.innerHTML).then(a => {
        alert('คัดลอกโค้ด: ' + textToCopyformUpdate.innerHTML)
      })
    },
    async getFriendForCheck () {
      const result = await this.callBeTaskAPI(
        'get',
        '/FriendGetFriend/get?shopId=' + this.shopId
      )
      if (result) {
        if (result.length > 0) {
          this.dataFriendGetFriend = result[0]
        }
      }
    },
    async getFriendForLog () {
      const result = await this.callBeTaskAPI(
        'get',
        '/Log_FriendGetFriend/get?shopId=' + this.shopId + '&inviteFrom=' + this.member.memberId
      )
      if (result) {
        if (result.length > 0) {
          this.dataFriendGetFriendLog = result
          this.countLog = this.dataFriendGetFriendLog.length
          this.allPoint = this.dataFriendGetFriendLog.reduce((accum, obj) => accum + obj.inviteFormGetPoint, 0)
        }
      }
    },
    async share () {
      const resultPara = document.querySelector('.result')
      // let url = encodeURIComponent(`https://betask-loyalty-web.web.app/home?shopId=${this.shopId}&type=welcome`)
      // let redicrecUrl = encodeURIComponent(`https://betask-loyalty-web.web.app/home?shopId=${this.shopId}`)
      // window.location = `https://www.facebook.com/v5.0/dialog/share?app_id=353978626320785&href=${url}`
      try {
        await navigator.share(this.shareData)
        resultPara.textContent = 'MDN shared successfully'
      } catch (err) {
        resultPara.textContent = `Error: ${err}`
      }
    },
    goBack () {
      window.history.back()
    },
    // async transactionVisitPage () {
    //   const result = await this.callBeTaskAPI(
    //     'post',
    //     `/TransactionVisitPage/add`, {
    //       page: 'Activity',
    //       shopId: this.member.shopId,
    //       CREATE_USER: this.member.lineUserId
    //     }
    //   )
    //   if (result) {
    //     console.log('reward', this.item)
    //   }
    // },
    async sendShareService () {
      if (this.dataFriendGetFriend.point_invitee_getsB > 0) {
        this.flex = [
          {
            'type': 'flex',
            'altText': 'Flex Message',
            'contents': {
              'type': 'bubble',
              'size': 'mega',
              'hero': {
                'type': 'image',
                'url': this.dataFriendGetFriend.pictureB,
                'size': 'full',
                'aspectRatio': '20:13',
                'aspectMode': 'cover',
                'action': {
                  'type': 'uri',
                  'uri': 'https://linecorp.com'
                }
              },
              'body': {
                'type': 'box',
                'layout': 'vertical',
                'spacing': 'md',
                'action': {
                  'type': 'uri',
                  'uri': 'https://linecorp.com'
                },
                'contents': [
                  {
                    'type': 'text',
                    'text': 'Friend get Friend',
                    'size': 'lg',
                    'weight': 'bold',
                    'style': 'normal',
                    'decoration': 'underline',
                    'position': 'relative',
                    'align': 'start',
                    'wrap': true,
                    'offsetTop': 'none',
                    'gravity': 'top'
                  },
                  {
                    'type': 'box',
                    'layout': 'vertical',
                    'spacing': 'sm',
                    'contents': [
                      {
                        'type': 'box',
                        'layout': 'baseline',
                        'contents': [
                          {
                            'type': 'text',
                            'text': this.dataFriendGetFriend.massageB,
                            'weight': 'bold',
                            'margin': 'sm',
                            'flex': 0,
                            'color': '#7d7575'
                          }
                        ],
                        'justifyContent': 'flex-start',
                        'alignItems': 'center',
                        'paddingAll': 'xs'
                      },
                      {
                        'type': 'box',
                        'layout': 'baseline',
                        'contents': [
                          {
                            'type': 'icon',
                            'url': 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png',
                            'offsetTop': 'sm',
                            'margin': 'xs'
                          },
                          {
                            'type': 'text',
                            'text': `${this.$t('message.inviteFri')}` + this.dataFriendGetFriend.point_invitee_getsB.toString() + `${this.$t('message.point')}`,
                            'weight': 'regular',
                            'margin': 'md',
                            'flex': 0,
                            'color': '#7d7575',
                            'size': 'xs'
                          }
                        ],
                        'justifyContent': 'flex-start',
                        'alignItems': 'center',
                        'paddingAll': 'xs'
                      }
                    ]
                  },
                  {
                    'type': 'button',
                    'style': 'primary',
                    'color': '#A144BC',
                    'margin': 'xxl',
                    'action': {
                      'type': 'uri',
                      'label': `${this.$t('message.regis')}`,
                      'uri': 'https://betask-linked.web.app/BookingForm?shopId=' + this.shopId + '&source=friendgetfriend&reFerId=' + this.member.memberId
                    }
                  }
                ],
                'paddingAll': 'lg'
              }
            }
          }
        ]
      } else {
        this.flex = [
          {
            'type': 'flex',
            'altText': 'Flex Message',
            'contents': {
              'type': 'bubble',
              'size': 'mega',
              'hero': {
                'type': 'image',
                'url': this.dataFriendGetFriend.pictureB,
                'size': 'full',
                'aspectRatio': '20:13',
                'aspectMode': 'cover',
                'action': {
                  'type': 'uri',
                  'uri': 'https://linecorp.com'
                }
              },
              'body': {
                'type': 'box',
                'layout': 'vertical',
                'spacing': 'md',
                'action': {
                  'type': 'uri',
                  'uri': 'https://linecorp.com'
                },
                'contents': [
                  {
                    'type': 'text',
                    'text': 'Friend get Friend',
                    'size': 'lg',
                    'weight': 'bold',
                    'style': 'normal',
                    'decoration': 'underline',
                    'position': 'relative',
                    'align': 'start',
                    'wrap': true,
                    'offsetTop': 'none',
                    'gravity': 'top'
                  },
                  {
                    'type': 'box',
                    'layout': 'vertical',
                    'spacing': 'sm',
                    'contents': [
                      {
                        'type': 'box',
                        'layout': 'baseline',
                        'contents': [
                          {
                            'type': 'text',
                            'text': this.dataFriendGetFriend.massageB,
                            'weight': 'bold',
                            'margin': 'sm',
                            'flex': 0,
                            'color': '#7d7575'
                          }
                        ],
                        'justifyContent': 'flex-start',
                        'alignItems': 'center',
                        'paddingAll': 'xs'
                      }
                    ]
                  },
                  {
                    'type': 'button',
                    'style': 'primary',
                    'color': '#A144BC',
                    'margin': 'xxl',
                    'action': {
                      'type': 'uri',
                      'label': `${this.$t('message.regis')}`,
                      'uri': this.link + this.shopId + '&reFerId=' + this.member.memberId + '&source=flex'
                    }
                  }
                ],
                'paddingAll': 'lg'
              }
            }
          }
        ]
      }
      const result = await this.$liff.shareTargetPicker(this.flex)
      if (result) {
        alert(`[${result.status}] Message sent!`)
      } else {
        const [majorVer, minorVer, patchVer] = (this.$liff.getLineVersion() || '').split('.')

        if (minorVer === undefined) {
          alert('ShareTargetPicker was canceled in external browser')
          return
        }

        if (parseInt(majorVer) >= 10 && parseInt(minorVer) >= 10 && parseInt(patchVer) > 0) {
          alert('ShareTargetPicker was canceled in LINE app')
        }
      }
    },
    async sendShareRegister () {
      if (this.dataFriendGetFriend.point_invitee_getsA > 0) {
        this.flex = [
          {
            'type': 'flex',
            'altText': 'Flex Message',
            'contents': {
              'type': 'bubble',
              'size': 'mega',
              'hero': {
                'type': 'image',
                'url': this.dataFriendGetFriend.pictureA,
                'size': 'full',
                'aspectRatio': '20:13',
                'aspectMode': 'cover',
                'action': {
                  'type': 'uri',
                  'uri': 'https://linecorp.com'
                }
              },
              'body': {
                'type': 'box',
                'layout': 'vertical',
                'spacing': 'md',
                'action': {
                  'type': 'uri',
                  'uri': 'https://linecorp.com'
                },
                'contents': [
                  {
                    'type': 'text',
                    'text': 'Friend get Friend',
                    'size': 'lg',
                    'weight': 'bold',
                    'style': 'normal',
                    'decoration': 'underline',
                    'position': 'relative',
                    'align': 'start',
                    'wrap': true,
                    'offsetTop': 'none',
                    'gravity': 'top'
                  },
                  {
                    'type': 'box',
                    'layout': 'vertical',
                    'spacing': 'sm',
                    'contents': [
                      {
                        'type': 'box',
                        'layout': 'baseline',
                        'contents': [
                          {
                            'type': 'text',
                            'text': this.dataFriendGetFriend.massageA,
                            'weight': 'bold',
                            'margin': 'sm',
                            'flex': 0,
                            'color': '#7d7575'
                          }
                        ],
                        'justifyContent': 'flex-start',
                        'alignItems': 'center',
                        'paddingAll': 'xs'
                      },
                      {
                        'type': 'box',
                        'layout': 'baseline',
                        'contents': [
                          {
                            'type': 'icon',
                            'url': 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png',
                            'offsetTop': 'sm',
                            'margin': 'xs'
                          },
                          {
                            'type': 'text',
                            'text': `${this.$t('message.regisGetPoint')}` + this.dataFriendGetFriend.point_invitee_getsA.toString() + `${this.$t('message.point')}`,
                            'weight': 'regular',
                            'margin': 'md',
                            'flex': 0,
                            'color': '#7d7575',
                            'size': 'xs'
                          }
                        ],
                        'justifyContent': 'flex-start',
                        'alignItems': 'center',
                        'paddingAll': 'xs'
                      }
                    ]
                  },
                  {
                    'type': 'button',
                    'style': 'primary',
                    'color': '#A144BC',
                    'margin': 'xxl',
                    'action': {
                      'type': 'uri',
                      'label': `${this.$t('message.regis')}`,
                      'uri': this.link + this.shopId + '&reFerId=' + this.member.memberId + '&source=flex'
                    }
                  }
                ],
                'paddingAll': 'lg'
              }
            }
          }
        ]
      } else {
        this.flex = [
          {
            'type': 'flex',
            'altText': 'Flex Message',
            'contents': {
              'type': 'bubble',
              'size': 'mega',
              'hero': {
                'type': 'image',
                'url': this.dataFriendGetFriend.pictureA,
                'size': 'full',
                'aspectRatio': '20:13',
                'aspectMode': 'cover',
                'action': {
                  'type': 'uri',
                  'uri': 'https://linecorp.com'
                }
              },
              'body': {
                'type': 'box',
                'layout': 'vertical',
                'spacing': 'md',
                'action': {
                  'type': 'uri',
                  'uri': 'https://linecorp.com'
                },
                'contents': [
                  {
                    'type': 'text',
                    'text': 'Friend get Friend',
                    'size': 'lg',
                    'weight': 'bold',
                    'style': 'normal',
                    'decoration': 'underline',
                    'position': 'relative',
                    'align': 'start',
                    'wrap': true,
                    'offsetTop': 'none',
                    'gravity': 'top'
                  },
                  {
                    'type': 'box',
                    'layout': 'vertical',
                    'spacing': 'sm',
                    'contents': [
                      {
                        'type': 'box',
                        'layout': 'baseline',
                        'contents': [
                          {
                            'type': 'text',
                            'text': this.dataFriendGetFriend.massageA,
                            'weight': 'bold',
                            'margin': 'sm',
                            'flex': 0,
                            'color': '#7d7575'
                          }
                        ],
                        'justifyContent': 'flex-start',
                        'alignItems': 'center',
                        'paddingAll': 'xs'
                      }
                    ]
                  },
                  {
                    'type': 'button',
                    'style': 'primary',
                    'color': '#A144BC',
                    'margin': 'xxl',
                    'action': {
                      'type': 'uri',
                      'label': `${this.$t('message.regis')}`,
                      'uri': this.link + this.shopId + '&reFerId=' + this.member.memberId + '&source=flex'
                    }
                  }
                ],
                'paddingAll': 'lg'
              }
            }
          }
        ]
      }
      const result = await this.$liff.shareTargetPicker(this.flex)
      if (result) {
        alert(`[${result.status}] Message sent!`)
      } else {
        const [majorVer, minorVer, patchVer] = (this.$liff.getLineVersion() || '').split('.')

        if (minorVer === undefined) {
          alert('ShareTargetPicker was canceled in external browser')
          return
        }

        if (parseInt(majorVer) >= 10 && parseInt(minorVer) >= 10 && parseInt(patchVer) > 0) {
          alert('ShareTargetPicker was canceled in LINE app')
        }
      }
    },
    async checkOpenBelinked () { // เช็คว่า shopId loyalty มีใน Belinked หรือป่าว
      const result = await axios.get(this.DNS_Link + `/lineconfig/get?shopId=${this.shopId}`)
      if (Array.isArray(result.data)) {
        if (result.data[0].liffMainIDLoyalty !== null) {
          this.liffId = result.data[0].liffMainIDLoyalty
        } else {
          this.liffId = '1656906322-JN5MM8Ep'
        }
      } else {
        this.liffId = '1656906322-JN5MM8Ep'
      }
      // let domain = 'https://liff.line.me/1656906322-JN5MM8Ep/'
      await axios
        .get(
          'https://api-belinked.betaskthai.tech' +
            '/sys_shop/get?shopId=' +
            this.shopId
        )
        .then(async (result) => {
          if (result.data.status === undefined) {
            this.link = 'https://liff.line.me/' + this.liffId + '/RegisterMember?type=loyaltyLinked&shopId='
          } else {

            this.link = 'https://liff.line.me/' + this.liffId + '/RegisterMember?shopId='
          }
        })
    }
  }
}
</script>
<style>
div.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}
.custom-dialog.v-dialog{
    margin: 10px;
}

.custom-dialog.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeCUSTOM/Activity/FriendGetFriend.vue